import {FC, useMemo} from "react";
import {Modal, Spin} from "antd";
import {StatisticModalProps} from "./types";
import StatisticItemForm from "./statistic-form/StatisticForm";

const StatisticModal: FC<StatisticModalProps> = (props) => {
  const {statisticController} = props
  const {isLoading, isModalOpen, form, toggleModal, selectedStatisticItem} = statisticController

  const title = useMemo(() => {
    return selectedStatisticItem ? "Редагувати запис" : "Додати запис"
  }, [selectedStatisticItem])


  return <Modal width={500} style={{top: 20}} title={title} open={isModalOpen} onOk={() => {
    form.submit()
  }}
                onCancel={toggleModal}
                cancelButtonProps={{title: "Закрити"}} okButtonProps={{children: "Зберегти"}}>
    <Spin spinning={isLoading}>
      <StatisticItemForm statisticController={statisticController}/>
    </Spin>
  </Modal>
}

export default StatisticModal